import { useTranslation } from 'react-i18next';
import { TransactionStatus } from '#shared/components/UI';
import { SubAccountsListsShow } from './types';

type SubAccountStatusBadgeProps = {
  subAccount: Pick<SubAccountsListsShow, 'AccountStatus' | 'IsActive'>;
};

// The Status cell of the list table and the Sub-Accounts drawer: Blocked wins over the active flag.
export default function SubAccountStatusBadge({ subAccount }: SubAccountStatusBadgeProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.SubAccountList' });

  if (subAccount.AccountStatus === 'Blocked') {
    return <TransactionStatus status="blocked" label={t('Attributes.blockedBadge', { defaultValue: 'Blocked' })} />;
  }

  return subAccount.IsActive ? (
    <TransactionStatus status="active" label={t('Attributes.activeBadge', { defaultValue: 'Active' })} />
  ) : (
    <TransactionStatus status="not active" label={t('Attributes.notActiveBadge', { defaultValue: 'Not Active' })} />
  );
}
